import { ArrowLeftIcon } from '@/components/icons'
import { Box, Button, Grid, Stack, Typography } from '@mui/material'
import classes from './styles.module.scss'
import useTranslation from '@/hooks/useTranslation'

interface MenuHeaderProps {
  title: string
  onBack?: (event: any) => void
  /**
   * Controls that apply to the whole screen. They sit on this bar rather than
   * on a row of their own below it: the bar already names the screen, and a
   * second row to hold three buttons cost the list a chunk of its height.
   */
  actions?: React.ReactNode
}

const DiscoverHeader = ({ title, onBack, actions }: MenuHeaderProps) => {
  const { t } = useTranslation()

  return (
    <Stack
      sx={{
        backgroundColor: 'background.overrideDefault',
      }}
      className={classes.root}
    >
      <Stack
        className={classes.leftBox}
        direction="row"
        spacing="10px"
        alignItems="center"
      >
        <Box>
          <Button
            variant="secondary"
            className={classes.btnBack}
            onClick={onBack}
          >
            <ArrowLeftIcon />
          </Button>
        </Box>
        <Box>
          <Grid>
            <Typography className={classes.subTitle}>
              {t('dataDiscovery')}
            </Typography>
          </Grid>
          <Grid>
            <Typography className={classes.title}>{title}</Typography>
          </Grid>
        </Box>
      </Stack>
      {actions ? <Box className={classes.actions}>{actions}</Box> : null}
    </Stack>
  )
}

export default DiscoverHeader
